import React from 'react';
import { getCountryOptions } from 'utils';
import { Select } from 'components/styled-primitives';
import { fjSelectTypes, fjSelectWidths } from 'components/primitives';

import ModalInputSection from '../../components/modal-input-section';

interface CountryCodeProps {
  value: string;
  onChange: (value: string) => void;
}

const CountryCode = ({ value, onChange }: CountryCodeProps): React.JSX.Element => {
  return (
    <ModalInputSection
      sectionTitle="Country Code"
      inputs={[
        {
          Component: Select,
          options: getCountryOptions(),
          id: 'country-code',
          value,
          onChange,
          keyExtractor: (val: string, i: number) => `${val}-${i}`,
          type: fjSelectTypes.LG,
          width: fjSelectWidths.FIT,
        },
      ]}
    />
  );
};

export default CountryCode;
